// BSL-DST §5 — Destek masası turları. Ekran başına en çok 3 balon, metin ≤ 140 karakter.
// Bir `data-tur` elemanı silinir/taşınırsa bu dosya aynı commit'te düzeltilir (çatı §12).
export default {
  ymKategori: {
    yol: "/yardim/ymkategorilistesi",
    adimlar: [
      { hedef: '[data-tur="ymkat-yeni"]', metin: "Müşterinin seçeceği konu başlıkları." },
      { hedef: '[data-tur="ymkat-sorumlu"]', metin: "Her kategorinin sorumlusu, o kategoriye gelen çağrıyı ilk görendir.", kavram: "sorumluAtanan" },
    ],
  },
  slaKural: {
    yol: "/yardim/ymslakurallari",
    adimlar: [
      { hedef: '[data-tur="sla-oncelik"]', metin: "Her öncelik için ilk yanıt ve çözüm süresi.", kavram: "oncelikSla" },
      { hedef: '[data-tur="sla-kaydet"]', metin: "Kaydedene kadar süreler yalnız öneridir." },
    ],
  },
  cagriListe: {
    yol: "/cagri/cagrilistesi",
    adimlar: [
      { hedef: '[data-tur="cagri-paylas"]', metin: "Müşteriniz destek formunu bu bağlantıdan açar." },
      { hedef: '[data-tur="cagri-satir"]', metin: "Gelen çağrıyı açıp «İşleme Al» ile üstlenin." },
      { hedef: '[data-tur="cagri-durum"]', metin: "Çözüldü işaretlenen çağrı birkaç gün sonra kendiliğinden kapanır.", kavram: "cozulduKapandi" },
    ],
  },
  // BSL-D2 (B-11): pencerede «İlk çağrıyı üstlenin» → yalnız üstlenme ve kapanma (kısa turda ikisi de görünür).
  cagriUstlen: {
    yol: "/cagri/cagrilistesi",
    pencere: true,
    adimlar: [
      { hedef: '[data-tur="cagri-satir"]', metin: "Gelen çağrıyı açıp «İşleme Al» ile üstlenin." },
      { hedef: '[data-tur="cagri-durum"]', metin: "Çözüldü işaretlenen çağrı birkaç gün sonra kendiliğinden kapanır.", kavram: "cozulduKapandi" },
    ],
  },
  cagriDuzenle: {
    yol: "/cagri/duzenlecagri",
    adimlar: [
      { hedef: '[data-tur="cagri-ata"]', metin: "Çağrıyı başka birine atayabilirsiniz; kategorinin sorumlusu değişmez.", kavram: "sorumluAtanan" },
      // CagriMesaj_MailGonderAsync: personelin mesajı çağrıyı açana gider (müşteri çağrısında müşteriye).
      { hedef: '[data-tur="cagri-yanit"]', metin: "Mesajınız çağrıyı açana e-postayla gider; müşteri çağrısında müşteriye." },
      { hedef: '[data-tur="cagri-coz"]', metin: "Çözümü yazıp «Çöz» düğmesine basın; çağrı Çözüldü olur." },
    ],
  },
  // DST-PAYLAS: Çağrı Listesi paylaşım penceresi açık gelir (bsl.pencereIstegi = "cagriPaylas").
  cagriPaylas: {
    yol: "/cagri/cagrilistesi",
    pencere: true,
    adimlar: [
      { hedef: '[data-tur="paylas-kopyala"]', metin: "Bağlantıyı kopyalayın; formu yalnız e-postası kayıtlı müşterileriniz kullanabilir." },
      { hedef: '[data-tur="paylas-dene"]', metin: "Kayıtlı bir müşterinin e-postasıyla deneyin, sonra çağrıyı Çözüldü ile kapatın." },
    ],
  },
};
